import { useCallback } from 'react';
import { useRouter } from 'next/router';
// Hooks
import { useGetCurrUser } from 'hooks';
import { useGuestPpvBuyFlow } from 'hooks/useGuestPpvBuyFlow';
import { useStreamNavigation } from 'hooks/useStreamNavigation';

export function useStreamPurchaseNavigation() {
  const router = useRouter();
  const { data: userData } = useGetCurrUser();
  const { startGuestPpvBuy } = useGuestPpvBuyFlow();
  const getStreamNavigationProps = useStreamNavigation(
    userData?.me?.id || null
  );

  const navigateToStream = useCallback(
    (
      stream: Parameters<typeof getStreamNavigationProps>[0],
      hasAccessToWatch: boolean
    ) => {
      const shouldCheckout = !hasAccessToWatch;

      if (shouldCheckout && !userData) {
        startGuestPpvBuy(stream.id);
        return;
      }

      const { linkUrl } = getStreamNavigationProps(stream, shouldCheckout);
      router.push(linkUrl);
    },
    [getStreamNavigationProps, router, startGuestPpvBuy, userData]
  );

  return {
    navigateToStream,
    getStreamNavigationProps,
    userData,
  };
}
